import { createAction } from 'typesafe-actions';

export enum SETTING {
  TOGGLE_SIDEBAR = 'settings/TOGGLE_SIDE_BAR',
  CHANGE_SIDE_ROLE = 'settings/CHANGE_SIDE_ROLE',
}

export const toggleSidebar = createAction(SETTING.TOGGLE_SIDEBAR)();
export const changeSideRole = createAction(SETTING.CHANGE_SIDE_ROLE)<string>();
